import React from 'react'

import { SvgIcon } from '../SvgIcon/SvgIcon.react'

type GallerySliderProps = {
	show: number
	infiniteLoop: boolean
	children: any
	showSlide: number
}
export default (props: GallerySliderProps) => {
	const { children, show, infiniteLoop, showSlide = 0 } = props
	const [currentIndex, setCurrentIndex] = React.useState(showSlide)
	const [length, setLength] = React.useState(children.length)
	const [isRepeating, setIsRepeating] = React.useState(infiniteLoop && children.length > show)
	const [transitionEnabled, setTransitionEnabled] = React.useState(true)
	const [touchPosition, setTouchPosition] = React.useState(0)

	// Set the length to match current children from props
	React.useEffect(() => {
		setLength(children.length)
		setIsRepeating(infiniteLoop && children.length > show)
	}, [children, infiniteLoop, show])

	React.useEffect(() => {
		if (isRepeating) {
			if (currentIndex === show || currentIndex === length) {
				setTransitionEnabled(true)
			}
		}
	}, [currentIndex, isRepeating, show, length])

	React.useEffect(() => {
		setCurrentIndex(showSlide)
	}, [showSlide])

	const next = () => {
		if (isRepeating || currentIndex < length - show) {
			setCurrentIndex((prevState) => prevState + 1)
		}
	}

	const prev = () => {
		if (isRepeating || currentIndex > 0) {
			setCurrentIndex((prevState) => prevState - 1)
		}
	}

	function handleTouchStart(e: React.TouchEvent): void {
		const touchDown = e.touches[0].screenX
		setTouchPosition(touchDown)
	}

	function handleTouchMove(e: React.TouchEvent): void {
		const touchDown = touchPosition

		if (touchDown === 0) {
			return
		}

		const currentTouch = e.touches[0].screenX
		const diff = touchDown - currentTouch

		if (diff > 5) {
			next()
		}

		if (diff < -5) {
			prev()
		}

		setTouchPosition(0)
	}

	const handleTransitionEnd = () => {
		if (isRepeating) {
			if (currentIndex === 0) {
				setTransitionEnabled(false)
				setCurrentIndex(length)
			} else if (currentIndex === length + show) {
				setTransitionEnabled(false)
				setCurrentIndex(show)
			}
		}
	}

	const renderExtraPrev = () => {
		const output = []
		for (let index = 0; index < show; index++) {
			output.push(children[length - 1 - index])
		}
		output.reverse()
		return output
	}

	const renderExtraNext = () => {
		const output = []
		for (let index = 0; index < show; index++) {
			output.push(children[index])
		}
		return output
	}

	return (
		<div className="w-full h-full flex flex-col">
			<div className="w-full h-full flex relative">
				{(isRepeating || currentIndex > 0) && (
					<button
						type="button"
						onClick={prev}
						className="absolute z-10 h-full lg:static lg:px-28 flex flex-col items-center justify-center"
					>
						<SvgIcon
							collectionName="seebad"
							iconName="chevron-left"
							className="text-white w-7 h-7"
						/>
					</button>
				)}
				<div className="w-full h-full overflow-hidden">
					<div
						onTouchStart={(e) => handleTouchStart(e)}
						onTouchMove={(e) => handleTouchMove(e)}
						onTransitionEnd={() => handleTransitionEnd()}
						className="flex h-full transition-transform duration-500"
						style={{
							transform: `translateX(-${currentIndex * (100 / show)}%)`,
							transition: !transitionEnabled ? 'none' : undefined,
						}}
					>
						{length > show && isRepeating && renderExtraPrev()}
						{children}
						{length > show && isRepeating && renderExtraNext()}
					</div>
				</div>
				{/* You can alwas change the content of the button to other things */}
				{(isRepeating || currentIndex < length - show) && (
					<button
						type="button"
						onClick={next}
						className="absolute z-10 h-full right-0 lg:right-auto  lg:static lg:px-28 flex flex-col items-center justify-center"
					>
						<SvgIcon
							collectionName="seebad"
							iconName="chevron-right"
							className="text-white w-7 h-7"
						/>
					</button>
				)}
			</div>
		</div>
	)
}
